import { useAuth } from '../../context/AuthContext.js';
import { isPickupMan } from '../../utils/networkMode.js';
import AddShipment from './AddShipment.js';
import PickupManAddShipment from './PickupManAddShipment.js';

const AddShipmentRoute = () => {
  const { user } = useAuth();
  if (isPickupMan(user)) {
    return <PickupManAddShipment />;
  }
  return <AddShipment />;
};

export default AddShipmentRoute;
